import axios from "axios";
import store from "../store/index";
import axiosUrl from "./axios.service";
import moment from "moment";
import router from "../router";
import createCustomStore from "../store/custom.store.js";

const API_URL = axiosUrl.getAxiosUrl();

class CustomersService {
  async getAllCountries() {
    return await axios
      .get(API_URL + `customers/getAllCountries`)
      .then(response => {
        store.commit("customers/updateCountriesList", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getCustomerById(id) {
    return await axios
      .get(API_URL + `customers/getCustomer?customerId=${parseInt(id)}`)
      .then(response => {
        store.commit("customers/fillCustomerDetails", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getAllCustomers(
    filterSearchTerm,
    filterByActivityStatus,
    sortBy,
    descending,
    page,
    pageSize,
    isVsNl,
    selectedProducts
  ) {
    return await axios
      .get(API_URL + "customers/getAllCustomers", {
        params: {
          filterSearchTerm: filterSearchTerm,
          isActive: filterByActivityStatus,
          sortBy: sortBy,
          descending: descending,
          index: page ? page - 1 : 0,
          size: pageSize ?? 50,
          isVsNl: isVsNl,
          products: selectedProducts != null ? selectedProducts + "" : null
        }
      })
      .then(response => {
        store.commit("customers/updateAllCustomers", response.data);
        store.commit("customers/updatePagination", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getCustomersByFilters(customerOwnerId) {
    return await axios
      .get(API_URL + "customers/getCustomersByFilters", {
        params: {
          customerOwnerId: customerOwnerId
        }
      })
      .then(response => {
        store.commit("customers/updateAllCustomersFiltered", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getCustomerForUser(userId) {
    return await axios
      .get(API_URL + "customers/getCustomerForUser", {
        params: {
          userId: userId
        }
      })
      .then(response => {
        store.commit("customers/updateCustomerForUser", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getCustomerOwnerForUser(userId) {
    return await axios
      .get(API_URL + "accountManagers/getAccountManagerForUser", {
        params: {
          userId: userId
        }
      })
      .then(response => {
        store.commit(
          "accountManagers/updateAccountManagerForUser",
          response.data
        );
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async deactivateCustomer(id) {
    return await axios
      .post(API_URL + `customers/deactivateCustomer`, {
        id: id
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async createNewCustomer(customer) {
    const customerPayload = {
      name: customer.name,
      emailSuffix: customer.emailSuffix,
      startDate: moment(customer.content.startDate, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      ),
      endDate: customer.content.endDate
        ? moment(customer.content.endDate, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null,
      demo: customer.content.demo,
      numberOfLicences: customer.content.numberOfLicences,
      crmIdentifier: customer.crmIdentifier,
      customerType: customer.customerType,
      accountManager: customer.accountManager,
      languageCode: customer.languageCode,
      debugEmail: customer.debugEmail,
      deliveryMethod: customer.deliveryMethod,
      customerSettings: {
        reminderInterval: customer.sas.reminderInterval,
        canAllCompleteTask: customer.sas.canAllCompleteTask,
        senderAddress: customer.sas.emailSendFrom,
        emailSignature: customer.sas.emailSignature,
        replyToEmail: customer.sas.emailReplyAddress,
        useCustomEmail: customer.sas.useCustomEmailAddress,
        useSso: customer.sas.ssoOr2Fa.toLowerCase() == "sso",
        use2Fa: customer.sas.ssoOr2Fa.toLowerCase() == "2fa"
      },
      firstCategorization: customer.sas.categorization1,
      secondCategorization: customer.sas.categorization2,
      tenantId: customer.sas.tenantId,
      sasStartDate: moment(customer.sas.sasStartDate, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      ),
      sasEndDate: customer.sas.sasEndDate
        ? moment(customer.sas.sasEndDate, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null,
      hasSelectedProductSas: customer.selectedProducts.includes("SAS"),
      hasSelectedProductContent: customer.selectedProducts.includes("Content")
    };

    const customStore = createCustomStore("/api/customers", null, "id");
    try {
      const response = await customStore.insert(customerPayload);
      if (response.data) {
        router.push({
          name: "EditCustomer",
          params: {
            id: response.data.id
          }
        });
      }
    } catch (error) {
      store.commit("customers/updateModalError", error.message);
      store.commit("customers/enableModalError");
    }
  }

  async updateCustomer(customer) {
    return await axios
      .post(API_URL + `customers/updateCustomer`, {
        id: customer.id.value,
        name: customer.name.value,
        demo: customer.demo.value,
        linkedinUrl: customer.linkedinUrl.value,
        twitterUrl: customer.twitterUrl.value,
        facebookUrl: customer.facebookUrl.value,
        baseUrl: customer.baseUrl.value,
        customerLogoPath: customer.customerLogoPath.value,
        isFomoAccess: customer.isFomoAccess.value,
        languageCode: customer.languageCode.value,
        deliveryMethod: customer.deliveryMethod.value,
        has2FA: customer.has2FA.value,
        useSSO: customer.useSSO.value,
        emailAddress: customer.emailAddress.value,
        phoneNumber: customer.phoneNumber.value,
        emailSuffix: customer.emailSuffix.value,
        debugEmail: customer.debugEmail.value,
        endDate:
          customer.endDate.value == null ||
          customer.endDate.value == "" ||
          customer.endDate.value === undefined
            ? null
            : moment(customer.endDate.value, "DD-MM-YYYY").format("YYYY-MM-DD"),
        startDate:
          customer.startDate.value == null ||
          customer.startDate.value == "" ||
          customer.startDate.value === undefined
            ? null
            : moment(customer.startDate.value, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              ),
        sasEndDate:
          customer.sasEndDate.value == null ||
          customer.sasEndDate.value == "" ||
          customer.sasEndDate.value === undefined
            ? null
            : moment(customer.sasEndDate.value, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              ),
        sasStartDate:
          customer.sasStartDate.value == null ||
          customer.sasStartDate.value == "" ||
          customer.sasStartDate.value === undefined
            ? null
            : moment(customer.sasStartDate.value, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
              ),
        numberOfLicences: customer.numberOfLicences.value,
        crmIdentifier: customer.crmIdentifier.value,
        customerType: customer.customerType.value,
        environmentType: customer.environment.value,
        accountManager: customer.accountManager.value,
        usesAIAssistant: customer.usesAIAssistant.value,
        //tags: customer.customerAudienceTags.value
        //.concat(customer.customerPurposesTags.value)
        //.concat(customer.customerLocationsTags.value),
        useCustomEmail: customer.useCustomEmail.value,
        canAllCompleteTask: customer.canAllCompleteTask.value,
        emailSignature: customer.emailSignature.value,
        replyToEmail: customer.replyToEmail.value,
        reminderInterval: customer.reminderInterval.value,
        senderAddress: customer.senderAddress.value,
        firstCategorization: customer.firstCategorization.value,
        secondCategorization: customer.secondCategorization.value,
        smtpServer:
          customer.smtpServer.value != null ? customer.smtpServer.value : null,
        smtpPassword:
          customer.smtpPassword.value != null
            ? customer.smtpPassword.value
            : null,
        smtpPort:
          customer.smtpPort.value != null ? customer.smtpPort.value : null,
        smtpUserName:
          customer.smtpUserName.value != null
            ? customer.smtpUserName.value
            : null,
        smtpUseSSL:
          customer.smtpUseSSL.value != null ? customer.smtpUseSSL.value : null,
        brevoApiKey:
          customer.brevoApiKey.value != null
            ? customer.brevoApiKey.value
            : null,
        graphTenantId:
          customer.graphTenantId.value != null
            ? customer.graphTenantId.value
            : null,
        graphClientId:
          customer.graphClientId.value != null
            ? customer.graphClientId.value
            : null,
        graphSecret:
          customer.graphSecret.value != null ? customer.graphSecret.value : null
      })
      .then(response => {
        store.commit("customers/fillCustomerDetails", response.data);
        store.commit("customers/enableSuccessfullyUpdatedDialog");
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getCustomerSelectedTags(customerId, tagType, tagTypeValue) {
    return await axios
      .get(
        API_URL +
          `customers/getCustomerSelectedTags?customerId=${customerId}&tagType=${tagTypeValue}`,
        {
          params: {
            culture: "nl"
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          var type = tagType.split(" ").join("");
          store.commit(
            "customers/setSelectedCustomer" + `${type}` + "Tags",
            response.data
          );
        }
      })
      .catch(error => {
        store.commit("scheme/updateModalError", error),
          store.commit("scheme/enableModalError");
      });
  }

  async deleteCustomer(id) {
    const customStore = createCustomStore("/api/customers", null, "id");
    try {
      await customStore.remove(id);
    } catch (error) {
      store.commit("customers/updateModalError", error.message);
      store.commit("customers/enableModalError");
    }
  }

  getCustomerTypes() {
    return axios
      .get(API_URL + `customers/getCustomerTypes`)
      .then(response => {
        store.commit("customers/updateCustomerTypesList", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getLanguageCodes() {
    return await axios
      .get(API_URL + `customers/getAllLanguageCodesEnums`)
      .then(response => {
        store.commit("customers/updateLanguageCodes", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getCustomerTypesNew() {
    return await axios
      .get(API_URL + `customers/getCustomerTypesNew`)
      .then(response => {
        store.commit("customers/updateCustomerTypesList", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }
  getEnvironmentTypes() {
    return axios
      .get(API_URL + `customers/getEnvironmentTypes`)
      .then(response => {
        store.commit("enums/updateEnvironmentTypesList", response.data);
      });
  }
  // getAccountManagersWithBasicInfo
  async getCustomerOwners() {
    return await axios
      .get(API_URL + `accountManagers/getAccountManagersWithBasicInfo`)
      .then(response => {
        store.commit(
          "accountManagers/updateAccountManagersBasicInfoList",
          response.data
        );
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getCustomersByType(type) {
    return await axios
      .get(API_URL + `customers/getCustomersByType?customerType=${type}`, {
        "Content-Type": "application/json"
      })
      .then(response => {
        store.commit(
          "customers/updateModalPieChartCustomersData",
          response.data
        );
        store.commit("customers/updateShowPieChartModal", true);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getPortalCustomers() {
    return await axios
      .get(API_URL + "customers/getPortalCustomers")
      .then(response => {
        store.commit("customers/updatePortalCustomersList", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit(
            "customers/updateModalError",
            error.response.data.message
          ),
            store.commit("customers/enableModalError");
        }
      });
  }

  async getNonPortalCustomers() {
    return await axios
      .get(API_URL + "customers/getNonPortalCustomers")
      .then(response => {
        store.commit("consumptionStats/updateCustomersList", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit(
            "customers/updateModalError",
            error.response.data.message
          ),
            store.commit("customers/enableModalError");
        }
      });
  }
  async deleteCustomerTenantId(id, customerId) {
    return await axios
      .post(API_URL + `customers/deleteCustomerTenant`, {
        id: id,
        customerId: customerId
      })
      .then(response => {
        store.commit("customers/updateCustomerTenantIdsList", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }
  async getDeliveryMethods() {
    return await axios
      .get(API_URL + `customers/getDeliveryMethods`)
      .then(response => {
        store.commit("customers/updateDeliveryMethodsList", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }
  async addCustomerTenant(id, customerId) {
    return await axios
      .post(API_URL + `customers/addCustomerTenant`, {
        tenantId: id,
        customerId: customerId
      })
      .then(response => {
        store.commit("customers/updateCustomerTenantIdsList", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }

  async getReminderIntervals() {
    return await axios
      .get(API_URL + `customers/getAllReminderIntervals`)
      .then(response => {
        store.commit("customers/updateReminderIntervalOptions", response.data);
      })
      .catch(error => {
        store.commit("customers/updateModalError", error.response.data),
          store.commit("customers/enableModalError");
      });
  }
}

export default new CustomersService();
